import { render, staticRenderFns } from "./m-manage-form.vue?vue&type=template&id=e0487832&scoped=true"
import script from "./m-manage-form.vue?vue&type=script&lang=js"
export * from "./m-manage-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0487832",
  null
  
)

export default component.exports